export default __webpack_public_path__ + "static/media/623-tile.fcd896f2.svg";